import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import logo from '@/assets/HiveMQIcons/industrial-storage.png'

function StoragePharmaNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={logo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Storage</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default StoragePharmaNode
